import * as tslib_1 from "tslib";
import { EventEmitter, OnInit, OnDestroy, Renderer2, ElementRef, SimpleChanges, OnChanges, NgZone, SecurityContext } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { interval, forkJoin } from 'rxjs';
import { FinAppToolService, FinappConsentService, ConsentCMSService } from '../services';
import { FINAPP_COOKIE_STRING, REFRESH_ACCOUNT_ERROR, SUCCESS, INSTANCE_ERROR, NO_MAPPING, FASTLINK_APP_ID, LINK_ACCNT_ID, EDIT_ACCNT_ID, FINAPP_MODULE_MESSAGE, FINAPP_RESIZE_MESSAGE, FINAPP_STATUS_MESSAGE, FINAPP_EXIT, FASTLINK, CONSENT_ACCEPTED, FINANCIAL_WELLNESS } from '../constants';
import { DomSanitizer } from '@angular/platform-browser';
var FinAppToolComponent = /** @class */ (function () {
    function FinAppToolComponent(renderer, formBuilder, finAppToolService, ngZone, domSanitizer, consentCMS, consentService) {
        this.renderer = renderer;
        this.formBuilder = formBuilder;
        this.finAppToolService = finAppToolService;
        this.ngZone = ngZone;
        this.domSanitizer = domSanitizer;
        this.consentCMS = consentCMS;
        this.consentService = consentService;
        this.errorOnSubmit = false;
        this.showFinAppIframe = false;
        this.visitedSystemsLabel = 'VisitedSystems=';
        this.domainInfo = '; path=/; domain=.prudential.com; Secure; SameSite=Lax;';
        this.finAppStatusOn = 'ON';
        this.finAppCloseEvent = false;
        this.hideConsent = true;
        this.isBudgetTool = false;
        this.doneLoading = new EventEmitter();
        this.syncApiStart = new EventEmitter();
        this.syncApiDone = new EventEmitter();
        this.logoutDone = new EventEmitter();
        this.yoodleeError = new EventEmitter();
        this.iFrameActivity = new EventEmitter();
        this.consentAccepted = new EventEmitter();
        this.closeValuePropModal = new EventEmitter();
        this.showErrorHandlingMsg = new EventEmitter();
        this.showLoadingScreen = new EventEmitter();
        this.finAppFormValues = { url: '', appId: 0, rsession: '', token: '', redirectReq: true, extraParams: '' };
    }
    FinAppToolComponent.prototype.onMouseMove = function (e) {
        this.mouseEventChanged = true;
    };
    FinAppToolComponent.prototype.ngOnInit = function () {
        var _this = this;
        // set if is budget tool
        this.isBudgetTool = this.finAppName && this.finAppName === FINANCIAL_WELLNESS ? true : false;
        this.init();
        this.checkIfConsentAccepted().subscribe(function (_a) {
            var _b = tslib_1.__read(_a, 2), res1 = _b[0], res2 = _b[1];
            if (res1 && res1['consents'] && res1['consents']['Yodlee_tnc']) {
                _this.bodyContent = _this.domSanitizer.sanitize(SecurityContext.HTML, res1['consents']['Yodlee_tnc']['body']);
                _this.currentVersionId = res1['consents']['Yodlee_tnc']['vid'];
            }
            var acceptedVid = res2['consentVersion'];
            var consentAccepted = res2['consentValue'] === CONSENT_ACCEPTED;
            if (consentAccepted && acceptedVid === _this.currentVersionId) {
                _this.consentAccepted.emit(true);
                _this.isConsentAccepted = true;
                _this.invokeEnvestnetLogin();
            }
            else {
                _this.showLoadingScreen.emit(false);
                _this.hideConsent = false;
                _this.consentAccepted.emit(false);
                _this.isConsentAccepted = false;
            }
        }, function (error) {
            _this.closeValuePropModal.emit(true);
            _this.showErrorHandlingMsg.emit('failedGetConsent');
        });
    };
    FinAppToolComponent.prototype.checkIfConsentAccepted = function () {
        var consentCMSObservable = this.consentCMS.getConsentMessages();
        var consentAcceptedObservable = this.consentService.getConsentInfo();
        return forkJoin([consentCMSObservable, consentAcceptedObservable]);
    };
    FinAppToolComponent.prototype.invokeEnvestnetLogin = function () {
        var _this = this;
        this.finAppToolService.invokeEnvestnetLogin(this.finAppName, this.extraParams).subscribe(function (response) {
            // console.log('Envestnest response: ', response);
            _this.finAppFormValues = response;
            _this.populateForm();
            _this.enableAggregationIframe();
            var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
            if (iOS) {
                if (jQuery('body').hasClass('modal-open')) {
                    jQuery('body.modal-open').css('overflow', 'visible');
                    jQuery('body.modal-open').css('-webkit-overflow-scrolling', 'touch');
                    jQuery('body.modal-open').css('position', 'fixed');
                }
            }
        }, function (error) {
            console.warn('ERROR: error occured logging into Envestnet ', error);
            _this.doneLoading.emit(false);
            _this.yoodleeError.emit('error occured logging into Envestnet, ' + error);
        });
    };
    FinAppToolComponent.prototype.ngOnChanges = function (change) {
        // If ngOnInit already called, and rsession results empty - retry with ngOnInit
        if (change.finAppClosed && change.finAppClosed.previousValue && (this.finAppFormValues.rsession === '')) {
            this.ngOnInit();
        }
        else if (change.finAppClosed && !change.finAppClosed.isFirstChange() && change.finAppClosed.currentValue
            && this.finAppFormValues.rsession !== '') {
            this.callRefreshAccount(this.finAppFormValues.rsession);
        }
        else if (change.finAppName && !change.finAppName.isFirstChange()
            && change.finAppName.currentValue && change.finAppName.currentValue.length > 0
            && !this.finAppToolService.instanceLoaded && this.finAppFormValues.rsession.length > 0) {
            // if there was an instance error and user tries to relaunch finapp need to call login again
            this.ngOnInit();
        }
    };
    FinAppToolComponent.prototype.ngOnDestroy = function () {
        jQuery('body').css('overflow', '');
        jQuery('body').css('position', '');
        jQuery('body.modal-open').css('-webkit-overflow-scrolling', '');
        // call logout if it hasn't been called already and there is still a valid rsession
        if (this.finAppFormValues.rsession !== '') {
            this.invokeYodleeLogout(this.finAppFormValues.rsession);
            if (this.subscription) {
                this.subscription.unsubscribe();
            }
        }
    };
    FinAppToolComponent.prototype.init = function () {
        this.yodleeForm = this.formBuilder.group({
            app: ['', Validators.required],
            rsession: ['', Validators.required],
            token: ['', Validators.required],
            redirectReq: ['', Validators.required],
            extraParams: [''],
        });
    };
    FinAppToolComponent.prototype.populateForm = function () {
        if (this.finAppFormValues) {
            this.yodleeForm.controls['app'].setValue(this.finAppFormValues.appId);
            this.yodleeForm.controls['rsession'].setValue(this.finAppFormValues.rsession);
            this.yodleeForm.controls['token'].setValue(this.finAppFormValues.token);
            this.yodleeForm.controls['redirectReq'].setValue(this.finAppFormValues.redirectReq);
            this.yodleeForm.controls['extraParams'].setValue(this.finAppFormValues.extraParams);
            if (this.finAppFormValues.url.includes('http')) {
                this.renderer.setAttribute(this.formEl.nativeElement, 'action', this.finAppFormValues.url);
            }
        }
        // setting rsession in service for logout if timeout occurs and component isn't avialabe
        this.finAppToolService.setRsession(this.finAppFormValues.rsession);
    };
    FinAppToolComponent.prototype.enableAggregationIframe = function () {
        // checking if another application has already launched a FinApp session
        var cookie = this.getVisitedSystemsCookie();
        if (cookie && !this.checkForLaunchingCookie(cookie)) {
            // warn and block launching of second app session
            console.warn('WARN: Another application has a FinApp session open...');
            this.doneLoading.emit(true);
            this.syncApiDone.emit(INSTANCE_ERROR);
        }
        else {
            if (this.yodleeForm.valid) {
                this.submitForm();
            }
        }
    };
    FinAppToolComponent.prototype.submitForm = function () {
        var _this = this;
        if (this.yodleeForm.valid) {
            // trigger form submission
            this.formEl.nativeElement.submit();
            // setting up callback on iframe load
            this.renderer.listen(this.iframeEl.nativeElement, 'load', function (event) {
                console.log('FINAPP ----->>>> Load iframe event');
                // if instance isn't loaded and load function called finish loading Finapp
                if (!_this.finAppToolService.instanceLoaded) {
                    // isIframeAlreadyLoaded = true;
                    _this.doneLoadingIframe(true);
                    _this.finAppToolService.instanceLoaded = true;
                }
            });
            // POST messages from Yodlee
            if (this.finAppName === FASTLINK) {
                this.messageListenFunc = this.renderer.listen(window, 'message', function (finappMessage) {
                    _this.handlePostMessage(finappMessage);
                });
            }
        }
        else {
            console.log('ERROR: errorOnSubmit: ', this.errorOnSubmit);
            this.doneLoading.emit(false);
        }
    };
    FinAppToolComponent.prototype.doneLoadingIframe = function (event) {
        var _this = this;
        // set or append to VisistedSystems cookie
        var cookie = this.getVisitedSystemsCookie();
        // causing cookie too large error and logging session out
        this.updateVistedSystemsCookie(cookie);
        if (event) {
            this.doneLoading.emit(event);
        }
        // iFrame has loaded, check mouse activity every 3 minutes = 180 seconds
        this.subscription = interval(180000)
            .subscribe(function () {
            // console.warn('--------------- Interval has beenkicked off... ' + this.mouseEventChanged  );
            if (_this.mouseEventChanged) {
                _this.mouseEventChanged = false;
                _this.iFrameActivity.emit(true);
            }
        });
    };
    FinAppToolComponent.prototype.getVisitedSystemsCookie = function () {
        var match = document.cookie.match(new RegExp('(^| )' + 'VisitedSystems' + '=([^;]+)'));
        if (match) {
            return match[2];
        }
    };
    FinAppToolComponent.prototype.updateVistedSystemsCookie = function (cookie) {
        // console.log('VisitedSystems Cookie = ', cookie);
        if (cookie) {
            if (this.checkForLaunchingCookie(cookie)) {
                cookie = cookie.concat(',' + FINAPP_COOKIE_STRING + this.finAppStatusOn.toUpperCase());
            }
        }
        else {
            cookie = FINAPP_COOKIE_STRING + this.finAppStatusOn.toUpperCase();
        }
        // write update cookie back to document
        document.cookie = this.visitedSystemsLabel + cookie + this.domainInfo;
    };
    FinAppToolComponent.prototype.removeFromVisitedSystemsCookie = function (cookie) {
        if (cookie) {
            cookie = cookie.replace((',' + FINAPP_COOKIE_STRING + this.finAppStatusOn), '');
            document.cookie = this.visitedSystemsLabel + cookie + this.domainInfo;
        }
    };
    FinAppToolComponent.prototype.checkForLaunchingCookie = function (cookie) {
        if (!cookie.includes(this.finAppStatusOn)) {
            return true;
        }
        return false;
    };
    FinAppToolComponent.prototype.callRefreshAccount = function (rsession) {
        var _this = this;
        this.syncApiStart.emit(true);
        this.finAppToolService.refreshAccount(rsession).subscribe(function (res) {
            console.log('res = ', res);
            if (res.status === 202) {
                _this.syncApiDone.emit(SUCCESS);
                _this.invokeYodleeLogout(rsession);
            }
            else if (res.status === 204) {
                _this.syncApiDone.emit(NO_MAPPING);
                _this.invokeYodleeLogout(rsession);
            }
        }, function (error) {
            _this.syncApiDone.emit(REFRESH_ACCOUNT_ERROR);
            _this.invokeYodleeLogout(rsession);
        });
    };
    FinAppToolComponent.prototype.invokeYodleeLogout = function (resssion) {
        var _this = this;
        this.finAppToolService.yodleeLogout(resssion).subscribe(function () {
            var cookie = _this.getVisitedSystemsCookie();
            _this.removeFromVisitedSystemsCookie(cookie);
            _this.clearFinAppFormValues();
            _this.logoutDone.emit(true);
            _this.finAppToolService.instanceLoaded = false;
            _this.iframeEl.nativeElement.remove();
            if (_this.messageListenFunc) {
                _this.messageListenFunc();
            }
            console.log('FinAppTool: Successful logout of Yodlee');
        }, function (error) {
            console.warn('ERROR: There was an error logging out of Yodlee', error);
            _this.logoutDone.emit(false);
            // retry logout if failure, not using rxjs retry() to emit event to consuming app on error
            _this.finAppToolService.yodleeLogout(resssion).subscribe(function () {
                var cookie2 = _this.getVisitedSystemsCookie();
                _this.removeFromVisitedSystemsCookie(cookie2);
                _this.clearFinAppFormValues();
                _this.logoutDone.emit(true);
                _this.finAppToolService.instanceLoaded = false;
                _this.iframeEl.nativeElement.remove();
                if (_this.messageListenFunc) {
                    _this.messageListenFunc();
                }
                console.log('FinAppTool: Successful logout of Yodlee');
            }, function (error2) {
                var cookie2 = _this.getVisitedSystemsCookie();
                _this.removeFromVisitedSystemsCookie(cookie2);
                _this.clearFinAppFormValues();
                _this.finAppToolService.instanceLoaded = false;
                _this.iframeEl.nativeElement.remove();
                if (_this.messageListenFunc) {
                    _this.messageListenFunc();
                }
                _this.logoutDone.emit(true);
            });
        });
    };
    FinAppToolComponent.prototype.clearFinAppFormValues = function () {
        this.finAppFormValues.appId = 0;
        this.finAppFormValues.extraParams = '';
        this.finAppFormValues.redirectReq = null;
        this.finAppFormValues.rsession = '';
        this.finAppFormValues.token = '';
        this.finAppFormValues.url = '';
    };
    FinAppToolComponent.prototype.resizeFinappIframe = function (data) {
        var _this = this;
        // forcing change detection so iframe will re-size
        this.ngZone.run(function () {
            // if height is NaN could be XSS issue or bad value, not setting height in that case
            if (data.finappId === FASTLINK_APP_ID && !isNaN(data.height)) {
                jQuery('#yoodleFinApp').animate({ scrollTop: 0 }, 'slow');
                _this.iframeEl.nativeElement.height = data.height;
            }
        });
    };
    // used to track which module finapp currently is loaded into
    // CURRENTLY NOT BEING USED, KEEPING FOR NOW, MIGHT REMOVE
    FinAppToolComponent.prototype.checkFinappLoadedModule = function (data) {
        if (data.containerFinapp && !this.finAppToolService.instanceLoaded) {
            if (data.finappModuleId === LINK_ACCNT_ID || data.finappModuleId === EDIT_ACCNT_ID) {
                // currently not doing anything, but could be used in the future
            }
        }
    };
    // exit was sent it status do widget clean up process
    FinAppToolComponent.prototype.checkFinappAccountStatus = function (data) {
        if (data.action === FINAPP_EXIT && this.finAppToolService.instanceLoaded) {
            this.callRefreshAccount(this.finAppFormValues.rsession);
        }
    };
    FinAppToolComponent.prototype.handlePostMessage = function (finappMessage) {
        // security checks before running any code
        // TODO: talk to John Hall about what exact security checks they want us to have to be considered secure
        var expectedOrigin = this.finAppFormValues.url.replace('/authenticate/prudentialpfm/', '');
        // sanitize incoming message before doing any other checks against message data
        var sanitizedMessage = this.domSanitizer.sanitize(SecurityContext.HTML, encodeURI(JSON.stringify(finappMessage.data)));
        // checking expected origin against what was sent and make sure it is trusted
        if (!finappMessage.isTrusted || finappMessage.origin !== expectedOrigin) {
            console.warn('[handlePostMessage]: message wasn\'t trusted or origin didn\'t match !!!');
            return;
        }
        if (sanitizedMessage.includes('script')
            || sanitizedMessage.includes('HTML')
            || sanitizedMessage.includes(')]}\',\n')) {
            console.warn('[handlePostMessage]: found something off in the message data so NOT processing it !!!');
            return;
        }
        // explicit check that there is a sanitized message and that the origin equals the expected and the
        if (sanitizedMessage && finappMessage.isTrusted && finappMessage.origin === expectedOrigin) {
            if (finappMessage.data.fnToCall === 'resizeFloater') {
                console.log('setNewThemeResizeFloater.data = ', finappMessage.data);
                this.resizeFinappIframe(this.transformToMessageInterface(JSON.parse(decodeURI(sanitizedMessage)), FINAPP_RESIZE_MESSAGE));
            }
            else if (finappMessage.data.fnToCall === 'newThemeResizeFloater') {
                console.log('setNewThemeResizeFloater.data = ', finappMessage.data);
                this.resizeFinappIframe(this.transformToMessageInterface(JSON.parse(decodeURI(sanitizedMessage)), FINAPP_RESIZE_MESSAGE));
            }
            else if (finappMessage.data.fnToCall === 'loadModule') {
                console.log('loadModule.data = ', finappMessage.data);
                this.checkFinappLoadedModule(this.transformToMessageInterface(JSON.parse(decodeURI(sanitizedMessage)), FINAPP_MODULE_MESSAGE));
            }
            else if (finappMessage.data.fnToCall === 'accountStatus') {
                console.log('accountStatus.data = ', finappMessage.data);
                this.checkFinappAccountStatus(this.transformToMessageInterface(JSON.parse(decodeURI(sanitizedMessage)), FINAPP_STATUS_MESSAGE));
            }
        }
    };
    // transform JSON message to new objects with typed interfaces to control what comes in and only use expected values
    FinAppToolComponent.prototype.transformToMessageInterface = function (data, interfaceName) {
        switch (interfaceName) {
            case FINAPP_MODULE_MESSAGE:
                var moduleData = {
                    containerFinapp: this.domSanitizer.sanitize(SecurityContext.HTML, data.containerFinapp) === 'true' ? true : false,
                    finappModuleId: this.checkIfValidFinAppModule(this.domSanitizer.sanitize(SecurityContext.HTML, data.finappId))
                };
                return moduleData;
            case FINAPP_RESIZE_MESSAGE:
                var resizeData = {
                    finappId: this.domSanitizer.sanitize(SecurityContext.HTML, data.finappId) === FASTLINK_APP_ID.toString() ? FASTLINK_APP_ID : 0,
                    height: Number(this.domSanitizer.sanitize(SecurityContext.HTML, data.height))
                };
                return resizeData;
            case FINAPP_STATUS_MESSAGE:
                var statusData = {
                    action: this.domSanitizer.sanitize(SecurityContext.HTML, data.action) === FINAPP_EXIT ? FINAPP_EXIT : 'status'
                };
                return statusData;
            default:
                return null;
        }
    };
    // checking that module id is valid finapp yodlee module id
    // TODO: enhance to support all module id's currently only supporting two
    FinAppToolComponent.prototype.checkIfValidFinAppModule = function (moduleId) {
        switch (moduleId) {
            case LINK_ACCNT_ID.toString():
                return LINK_ACCNT_ID;
            case EDIT_ACCNT_ID.toString():
                return EDIT_ACCNT_ID;
            default:
                return null;
        }
    };
    FinAppToolComponent.prototype.close = function () {
        this.closeValuePropModal.emit(true);
        this.hideConsent = true;
    };
    FinAppToolComponent.prototype.acceptConsent = function () {
        var _this = this;
        var payload = { consentValue: CONSENT_ACCEPTED, consentVersion: this.currentVersionId };
        this.consentService.saveConsentInfo(payload).subscribe(function (res) {
            if (res && res.status === 202) {
                _this.consentAccepted.emit(true);
                _this.hideConsent = true;
                _this.isConsentAccepted = true;
                _this.showLoadingScreen.emit(true);
                _this.invokeEnvestnetLogin();
            }
            else {
                _this.failedToSaveConsent();
            }
        }, function (error) {
            _this.failedToSaveConsent();
        });
    };
    FinAppToolComponent.prototype.failedToSaveConsent = function () {
        this.consentAccepted.emit(false);
        this.closeValuePropModal.emit(true);
        this.hideConsent = true;
        this.showErrorHandlingMsg.emit('failedSaveConsent');
    };
    return FinAppToolComponent;
}());
export { FinAppToolComponent };
